/**
 * Make redirect in native mode or web mode.
 * @param {string} callback link to redirect.
 * @param {boolean} isWebView determines if the redirect is native or web.
 */
import { WEBKIT_ENGINE } from '../../app/types/enums';

const makeRedirection = ({ callback, isWebView }) => {
  if (isWebView) {
    if (window.MobileWebKit.engine === WEBKIT_ENGINE.V200) {
      return window.MobileWebKit.navigation.push(callback);
    }

    return window.MobileWebKit.executeNative({
      method: 'open_internal_deeplink',
      args: {
        deeplink: callback,
        replace: false,
      },
      callback() {
        window.MobileWebKit.executeNative({
          method: 'close',
        });
      },
    });
  }

  return window.location.assign(callback);
};

export { makeRedirection };
